import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=2e8e959b"
import script from "./CustomDropdown.vue?vue&type=script&lang=ts"
export * from "./CustomDropdown.vue?vue&type=script&lang=ts"
import style0 from "./CustomDropdown.vue?vue&type=style&index=0&id=2e8e959b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports